// src/context/AppContext.js
import { createContext, useContext, useState } from "react";
import { useAuth } from "../hooks/useAuth";
const AppContext = createContext();

export const AppProvider = ({ children }) => {

  const [Rightmenut, setRightmenu] = useState(false);
  const [Leftmenu, setLeftmenu] = useState(false);
  const [search, setSearch] = useState(false);
 
  const {  login, logout } = useAuth();

  return (
    <AppContext.Provider value={{ Rightmenut, setRightmenu, Leftmenu, setLeftmenu, search, setSearch,  login, logout }}>
      {children}
    </AppContext.Provider>
  );
};

// custom hook for easy use
export const useApp = () => useContext(AppContext);
